import { useEffect } from 'react'
import classNames from 'classnames'
import { Text } from '../..'
import { SearchBar } from './SearchBar'
import { TAB_NAMES } from '../../../constants/navigation'
import { defineMessages, useIntl } from 'react-intl'
import { setActiveTab } from '../../../actions/navigation'
import { useSelector, useDispatch } from 'react-redux'
import { fetchSavedSearches } from '../../../actions/savedSearches'
import { SearchFeatureSections } from './SearchFeatureSections'
import { ChromebotFeatureSection } from './ChromebotFeatureSection'
import { selectCustomerId } from '../../../store/selectors/customerProfile'
import { useTheme } from '@homebot/shared-ui-swashbuckle'

import styles from './Search.module.scss'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.search.heading',
    defaultMessage: "Focus on finding your home. We'll crunch the numbers.",
  },
})

export const Search = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const customerId = useSelector(selectCustomerId)
  const { theme } = useTheme()

  useEffect(() => {
    dispatch(setActiveTab(TAB_NAMES.SEARCH))
    dispatch(fetchSavedSearches(customerId))
  }, [dispatch, customerId])

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div
          className={classNames(styles.searchWrapper, {
            [styles.lightBg]: theme.isLightThemeType,
            [styles.hbDefaultBg]: !theme.isLightThemeType,
          })}
        >
          <div className={styles.search}>
            <Text element='h1' className={styles.title}>
              {intl.formatMessage(MSG.heading)}
            </Text>
            <SearchBar />
          </div>
        </div>
        <SearchFeatureSections />
        <ChromebotFeatureSection />
      </div>
    </div>
  )
}
